
export const GAS_PRICE = '2000000000';

// export const CONTRACT_ADDRESS = '0x7b82756e5580d3d3ff6c139e7e8258b9a35d8918';
// export const CONTRACT_ADDRESS = '0xcd65fb460141a56b913700000500c02d849d1632';
// export const CONTRACT_ADDRESS = '0x345ca3e014aaf5dca488057592ee47305d9b3e10';
// export const CONTRACT_ADDRESS = '0x82d50ad3c1091866e258fd0f1a7cc9674609d254';
// export const CONTRACT_ADDRESS = '0xf204a4ef082f5c04bb89f7d5e6568b796096735a';
// export const CONTRACT_ADDRESS = '0x63cc86085347c8ea06dea85406e3c2ad5d632960';

export const CONTRACT_ADDRESS = '0x2c06e48f6e655bcfc7e46586784fb6da82c4ca3d';

export const EXPLORER = 'https://etherscan.io/tx/';
